import { isAxiosError } from 'axios'

export const getApiErrorCode = (error: unknown): number | undefined => {
  if (!isAxiosError(error)) return undefined
  const data = error.response?.data as Record<string, unknown> | undefined
  const code = data?.errCode
  return typeof code === 'number' ? code : undefined
}
